import { useEffect } from "react";

const Notification = ({ message, type = "info", onClose, notification }) => {
  // Handle both string and object formats
  const alertMessage = notification?.message || message;
  const alertType = notification?.type || type;
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000); // Auto close after 3 seconds
    return () => clearTimeout(timer);
  }, [onClose]);

  // Define styles based on alert type
  const getAlertStyles = () => {
    switch (alertType) {
      case "success":
        return "text-green-800 border-green-300 bg-green-50 dark:text-green-500 dark:bg-black dark:border dark:border-green-500";
      case "error":
        return "text-red-800 border-red-300 bg-red-50";
      case "warning":
        return "text-yellow-800 border-yellow-300 bg-yellow-50";
      case "info":
      default:
        return "text-blue-800 border-blue-300 bg-blue-50";
    }
  };

  return (
    <div 
      className={`fixed top-4 right-4 p-4 mb-4 text-sm font-poppins border rounded-lg z-[100] ${getAlertStyles()}`} 
      role="alert">
      <div className="capitalize">
        {alertMessage}
      </div>
    </div>
  );
};

export default Notification;